// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2ksVx","emails":"CreateEditClinics_emails__9086l","emailTagLabel":"CreateEditClinics_emailTagLabel__2i26b"};